import { memo } from 'react';

import LoadingButton from '@zenbusiness/zui/LoadingButton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import DirectionTypeIcon from '#client/components/TransactionDirectionTypeIcon';
import { DATE_FORMAT } from '#client/constants/date';
import { MODAL_NAMES } from '#client/constants/modals';
import { TRANSACTION_DIRECTION } from '#client/constants/transaction';
import useModalContext from '#client/hooks/useModalContext';

import { StackStyled } from './CheckDepositRow.styles';

function CheckDepositNeedReviewRow({ id, summary, createdAt }) {
  const createAtText = dayjs(createdAt).format(DATE_FORMAT.PRIMARY);
  const { openModal } = useModalContext();

  const handleNeedReview = () => {
    openModal({
      name: MODAL_NAMES.CHECK_DEPOSIT_RESUBMIT_MODAL,
      checkId: id
    });
  };

  return (
    <StackStyled
      minHeight="67px"
      pl="8px"
      pr="8px"
      role="listitem"
      width="100%"
    >
      <StackStyled width="85%">
        <Stack
          alignItems="center"
          direction="row"
          spacing={{ xs: '16px', md: '32px' }}
        >
          <Stack>
            <DirectionTypeIcon direction={TRANSACTION_DIRECTION.CREDIT} />
          </Stack>
          <Stack
            alignItems="start"
            direction="column"
            spacing="4px"
          >
            <Text
              color="primary"
              size="md"
              weight="medium"
            >
              {summary}
            </Text>
            <Text
              color="secondary"
              size="xs"
              whiteSpace="nowrap"
            >
              {createAtText}
            </Text>
          </Stack>
        </Stack>
      </StackStyled>
      <LoadingButton
        color="error"
        onClick={handleNeedReview}
        size="small"
        variant="contained"
      >
        Needs Review
      </LoadingButton>
    </StackStyled>
  );
}

CheckDepositNeedReviewRow.propTypes = {
  id: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired
};

export default memo(CheckDepositNeedReviewRow);
